import React from 'react';

/**
 * Components
 */
import Header from './Header';
import BrandTypeSection from './BrandTypeSection';
import NotesSection from './NotesSection';
import GeneralInformation from './GeneralInformation';
import ChangeStatus from './ChangeStatus';
import ApplicationActions from 'Components/ApplicationActions';
import ContactDetails from './ContactDetails'
import ESignDownloadSection from './ESignDownloadSection'

export default class DetailsApplication extends React.Component {
  _handleBackClick = () => {
    const {user} = this.props;

    user.goBack();
  };

  render() {
    const { user, match, applicationData, createActionsList, updateListEntry, deleteListEntry, selectAction } =
      this.props;
    const { applicationId } = match.params;

    if (!applicationData) {
      return (
        <section className='scene__scene-wrapper'>
          <section className='scene__content-wrapper detailsScene__content-wrapper'>
            <Header user={user} loadInProgress={true} />
            <div className='ect-spinner _width_pc_100 _height_120'>
              <div className='ect-spinner__image' />
            </div>
          </section>
        </section>
      );
    } else {
      const {
        applicationStatus,
        number,
        year,
        isPaid,
        submissionDate,
        approvalDate,
        name,
        formulaBaseOilNumber,
        formulaEngineType,
        description,
        submittedBy,
        manufacturerAddress,
        notes,
      } = applicationData;
      const availableActions = createActionsList(applicationData);

      return (
        <section className='scene__scene-wrapper'>
          <section
            className={`scene__content-wrapper detailsScene__content-wrapper ${applicationStatus.toLowerCase()}`}
          >
            <Header
              applicationStatus={applicationStatus}
              applicationId={applicationId}
              availableActions={availableActions}
              user={user}
              loadInProgress={!applicationData}
            />
            <BrandTypeSection number={number} year={year} isPaid={isPaid} />
            <GeneralInformation
              submissionDate={submissionDate}
              approvalDate={approvalDate}
              name={name}
              formulaBaseOilNumber={formulaBaseOilNumber}
              formulaEngineType={formulaEngineType}
              description={description}
            />
            <NotesSection notes={notes} />
            <ContactDetails submittedBy={submittedBy} manufacturerAddress={manufacturerAddress} />
            <ChangeStatus
              user={user}
              applicationId={applicationId}
              applicationData={applicationData}
              updateListEntry={updateListEntry}
              deleteListEntry={deleteListEntry}
              selectAction={selectAction}
              availableActions={availableActions}
            />
            <ESignDownloadSection
              applicationId={applicationId}
              name={name}
              licenseAgreementList={applicationData.licenseAgreementList}
            />
            <ApplicationActions backButtonLabel='Back' backButtonAction={this._handleBackClick} />
          </section>
        </section>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/Application/Details/index.jsx